module.exports = __webpack_public_path__ + "static/media/ft2-1.298d5420.jpg";